
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useState } from 'react';

export default function TestimonialSection() {
  const { t } = useTranslation('common');
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      review: t('testimonial.review'),
      name: t('testimonial.name'),
      company: t('testimonial.company'),
      avatar: 'https://public.readdy.ai/ai/img_res/ce9f33013b230cf67dbb1818b0a9528f.jpg'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-4xl font-serif text-center text-gray-900 mb-16"
        >
          {t('testimonial.title')}
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="bg-white rounded-3xl p-12 shadow-lg"
        >
          <div className="mb-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-gray-900 text-white rounded-full">
              <i className="ri-star-fill text-amber-400"></i>
              <span className="font-semibold">{t('testimonial.rating')}</span>
            </div>
          </div>

          <blockquote className="text-xl text-gray-700 leading-relaxed mb-8 font-serif">
            "{testimonials[currentIndex].review}"
          </blockquote>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-full overflow-hidden">
                <img
                  src={testimonials[currentIndex].avatar}
                  alt={testimonials[currentIndex].name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div>
                <p className="font-semibold text-gray-900 text-lg">
                  {testimonials[currentIndex].name}
                </p>
                <p className="text-sm text-gray-600">
                  {testimonials[currentIndex].company}
                </p>
              </div>
            </div>

            <div className="flex gap-2">
              <button
                onClick={() => setCurrentIndex(Math.max(0, currentIndex - 1))}
                className="w-12 h-12 border-2 border-gray-300 rounded-lg flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer"
                disabled={currentIndex === 0}
              >
                <i className="ri-arrow-left-line text-gray-600"></i>
              </button>
              <button
                onClick={() => setCurrentIndex(Math.min(testimonials.length - 1, currentIndex + 1))}
                className="w-12 h-12 bg-gray-900 text-white rounded-lg flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer"
                disabled={currentIndex === testimonials.length - 1}
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
